<template>
  <div class="pt-3 px-3 pb-1">
           
      <p v-if="contacts.length == 0" class="text-center">No contacts</p>

        <div v-else >

       <!--- Desktop --->
        <table class="table d-none d-md-table">
              <thead class="thead-dark">
                <tr>
                  <th class="first-left pl-3" width="30%">{{total}}</th>
                  <th class="pl-3" width="20%">Updated</th>
                  <th class="pl-3" width="15%">Sent</th>
                  <th class="first-right px-3" width="15%">Action</th>
                </tr>
              </thead>
              <tbody>
    <tr v-for="(contact, index) in contacts" :key="index">
        <td class="pl-3"><a href="/accounts" target="_blank">{{contact.email}}</a></td>
        <td class="pl-3 text-nowrap"><timeago
                  :datetime="contact.updated_at"
                  :auto-update="60"
                  :title="formatDateMoment(contact.updated_at)"></timeago></td>
        <td class="pl-3">{{contact.emails_sent}}</td>
        <td class="pl-3">
          <a href="#/" title="View contact" @click="showModalViewContact(contact)"><i class="fa-solid fa-eye mr-4"></i></a>
          <a href="#/" title="Edit contact" @click="showModalEditContact(contact)"><i class="fa-solid fa-pen-to-square"></i></a>
        </td>
    </tr>
              </tbody>
            </table>

        <!--- Mobile --->
        <table class="table d-md-none">
            <thead class="thead-dark">
                <tr>
                  <th class="first-left first-right text-center">Name • Email • Created</th>
                </tr>
              </thead>
          <tbody>
            <tr v-for="(contact, index) in contacts" :key="index">
  
        <td class="pl-2 text-center">
            <div><b>{{contact.name}}</b></div>
            <div>{{contact.email}}</div>
            <div><timeago
                  :datetime="contact.updated_at"
                  :auto-update="60"
                  :title="formatDateMoment(contact.updated_at)"></timeago></div>
          <div>
            <a href="#/" title="View contact" @click="showModalViewContact(contact)"><i class="fa-solid fa-eye mr-4"></i></a>
            <a href="#/" title="Edit contact" @click="showModalEditContact(contact)"><i class="fa-solid fa-pen-to-square"></i></a>
          </div>
        </td>
      
            </tr>
          </tbody>
        </table>

        </div>
  <view-contact v-if="contactInfo" :contact="contactInfo" :page="page" ref="ViewContact"></view-contact>
  <edit-contact v-if="contactInfo" :contact="contactInfo" :page="page"></edit-contact>
          </div>

</template>

<script>
export default {
  props: ['search_term','page'],

  watch: {
    search_term: function (val) {
      this.getContacts();
    }
  },

  data() {
    return {
      contacts: [],
      contactInfo: {},
      loading: false,
      total: 0
    };
  },

  created() {
    this.getContacts();

    Echo.private("contacts")
      .listen("UpdateRegistered", (event) => {
        this.getContacts();
      });

  },

  methods: {

    showModalViewContact(contact) {
      this.contactInfo = contact;
      this.$refs.ViewContact.cancelDelete();
      this.$bvModal.show('bv-modal-view-contact-'+this.page);
    },

    showModalEditContact(contact) {
      this.contactInfo = contact;
      this.$bvModal.show('bv-modal-edit-contact-'+this.page);
    },

    getContacts() {

      this.loading = true;

      axios
        .post('/contacts/registered', {
          search_term: this.search_term
        })
        .then((response) => {
          this.contacts = response.data.contacts;
          this.total = response.data.total;
          this.loading = false;
        });
    },

  },
};
</script> 